module.exports = __webpack_public_path__ + "img/fire1.3f1bc774.jpg";